import React, { useState, useEffect } from "react";
import { Check } from "lucide-react";

const SubscriptionPlans = () => {
  const [userId, setUserId] = useState("");

  useEffect(() => {
    const customerProfile = localStorage.getItem("customerProfile");
    if (customerProfile) {
      try {
        const parsed = JSON.parse(customerProfile);
        setUserId(parsed.id || localStorage.getItem("customerEmail") || "");
      } catch (e) {
        setUserId(localStorage.getItem("customerEmail") || "");
      }
    } else {
      setUserId("");
    }
  }, []);

  const plans = [
    {
      name: "Basic Plan",
      price: "$5",
      duration: "per month",
      description: "Perfect for getting started.",
      features: ["Access to basic features", "Email support", "1 User account"],
      buttonColor: "bg-gray-800 hover:bg-gray-700",
      popular: false,
    },
    {
      name: "Pro Plan",
      price: "$10",
      duration: "per month",
      description: "Best for regular users.",
      features: ["All Basic features", "Priority support", "5 User accounts", "Analytics dashboard"],
      buttonColor: "bg-[#82b016] hover:bg-[#679006]",
      popular: true,
    },
    {
      name: "Premium Plan",
      price: "$20",
      duration: "per month",
      description: "For power users & teams.",
      features: ["All Pro features", "24/7 Phone support", "Unlimited accounts", "Custom integrations"],
      buttonColor: "bg-gray-800 hover:bg-gray-700",
      popular: false,
    },
  ];

  return (
    <div className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
            Choose Your Subscription Plan
          </h2>
          <p className="mt-4 text-xl text-gray-600">
            Select the perfect plan that fits your needs and get started today.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`relative bg-white rounded-2xl shadow-lg transition-transform duration-300 hover:-translate-y-2 border ${plan.popular ? "border-[#82b016] shadow-xl md:scale-105 z-10" : "border-gray-200"
                } p-8 flex flex-col h-full`}
            >
              {plan.popular && (
                <div className="absolute top-0 inset-x-0 -mt-4 flex justify-center">
                  <span className="bg-[#82b016] text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide">
                    Most Popular
                  </span>
                </div>
              )}

              <div className="text-center mb-6">
                <h3 className="text-2xl font-semibold text-gray-900">{plan.name}</h3>
                <p className="text-gray-500 mt-2">{plan.description}</p>
                <div className="mt-6">
                  <span className="text-4xl font-extrabold text-gray-900">{plan.price}</span>
                  <span className="text-base font-medium text-gray-500">/{plan.duration}</span>
                </div>
              </div>

              <ul className="flex-1 space-y-4 mb-8">
                {plan.features.map((feature, i) => (
                  <li key={i} className="flex items-start">
                    <Check className="h-5 w-5 text-[#82b016] shrink-0 mr-3" />
                    <span className="text-gray-600">{feature}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-auto">
                <a
                  href={`https://sapodil.api.pbshope.in/verify?id=${userId || "guest"}&price=${plan.price.replace('$', '')}`}
                  className={`block w-full py-3 px-4 text-center rounded-xl font-bold text-white transition-colors duration-300 ${plan.buttonColor}`}
                >
                  Choose Plan
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SubscriptionPlans;
